import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
// import Home from 'pages/home/Home';

// render - login
const ProductsPath = Loadable(lazy(() => import('components/products/index')));
// const LoginPath = Loadable(lazy(() => import('pages/authentication/Login')));

// ==============================|| AUTH ROUTING ||============================== //

const ProductRoutes = {
  path: '/products',
  element: <ProductsPath />
};

export default ProductRoutes;
